import { render, staticRenderFns } from "./MobileAppFooter.vue?vue&type=template&id=be60b3ce&scoped=true"
import script from "./MobileAppFooter.vue?vue&type=script&lang=js"
export * from "./MobileAppFooter.vue?vue&type=script&lang=js"
import style0 from "./MobileAppFooter.vue?vue&type=style&index=0&id=be60b3ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be60b3ce",
  null
  
)

export default component.exports